<template>
  <header>
    <!-- Navbar -->
    <nav class="navbar navbar-expand-lg navbar-dark navbar-custom fixed-top">
      <div class="container px-5">
        <a class="navbar-brand" href="#page-top">
          <img src="./assets/img/6811.png" class="d-block" alt="1" width="160px"
        /></a>
        <div class="mobile-display">
          <Slide right>
            <a id="home" :href="registerHref">
              <span>สมัครสมาชิก</span>
            </a>
            <a id="home" :href="loginHref"> <span>เข้าสู่ระบบ</span> </a>
          </Slide>
        </div>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarResponsive"
          aria-controls="navbarResponsive"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarResponsive">
          <ul class="navbar-nav ms-auto">
            <li class="nav-item">
              <a class="link-in p-2 m-2" :href="registerHref">
                สมัครสมาชิก
              </a>
            </li>
            <li class="nav-item">
              <a class="link-in p-2" :href="loginHref">
                เข้าสู่ระบบ
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- Navbar -->
  </header>
</template>

<script>
import { Slide } from "vue-burger-menu"; // import the CSS transitions you wish to use, in this case we are using `Slide`

import "bootstrap/dist/css/bootstrap.min.css";
export default {
  components: { Slide },
  computed: {
    loginHref: function() {
      return process.env.VUE_APP_LOGIN_HREF;
    },
    registerHref: function() {
      return process.env.VUE_APP_REGISTER_HREF;
    },
  },
  name: "app",
  data() {
    return {};
  },
  props: {},

  methods: {},
};
</script>
<style></style>
